<script>
import { mapState } from 'vuex';
import BaseAddonCard from '@/views/config/addon-cards/templates/base.vue';
import DIDIcon from '@/assets/plans/dedicated_dial_in_number.svg';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { isDIDPlan } from './common';

export default {
  for: ([, , selectedPlans] = []) => {
    return pageConfig.type === flowTypes.edit && selectedPlans.some((plan) => plan.type === planTypes.TOLLFREE);
  },

  name: 'DIDAddonCard',
  extends: BaseAddonCard,

  data() {
    return {
      logo: DIDIcon,
      title: this.$t('billing.tollfree.dedicated_dial_in_number.title'),
      subtitle: '',
      description: this.$t('billing.tollfree.dedicated_dial_in_number.desc'),
    };
  },

  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    DIDPlans({ planMapFlat }) {
      return planMapFlat.filter(isDIDPlan);
    },
    DIDPlan({ DIDPlans }) {
      return DIDPlans.find((plan) => plan.billing_cycle === BILLING_CYCLE.MONTHLY) || {};
    },
  },

  created() {
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(this.DIDPlan.amount)]);
  },
};
</script>
